import * as authActions from "../../redux/auth/auth.actions";
export var isPerformingSubmitActionSelector = function () { return function (state) {
    return state.auth.isSignUpVerifyingPhone || state.auth.isFetchingUser;
}; };
export var performingSubmitActionResultSelector = function () { return function (state) {
    return state.auth.user;
}; };
export var performingSubmitActionErrorSelector = function () { return function (state) {
    return state.auth.signUpVerifyPhoneError || state.auth.fetchUserError;
}; };
export var submitActionCreator = function () { return function (formData) {
    return authActions.signUpVerifyPhone.actions.start(formData);
}; };
